import { makeStateKey } from '@angular/core';

import { INITIAL_LANGUAGE_STATE_KEY } from '@ppg/core/constants';

export const initialLanguageStateKey = makeStateKey<string>(INITIAL_LANGUAGE_STATE_KEY);
